/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 12/10/2020
 */

import mergeProps from "@/router/utils/mergeProps";

let EventTypeGeneralSettingsView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/EventTypes/Settings/SchedulerGeneralSettings')
let EventTypeAdditionalSettingsView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/EventTypes/Settings/SchedulerAdditionalSettingsView')
let EventTypeAvailabilitySettingsView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/EventTypes/Settings/EventTypeAvailabilitySettingsView.vue')
let SessionIntakeFormView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/EventTypes/Settings/SessionIntakeFormView.vue')
let SchedulerForms = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/EventTypes/Settings/SchedulerForms.vue')
let SchedulerIntakeForm = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/EventTypes/Settings/SchedulerForms/Forms/SchedulerIntakeForm.vue')
let SchedulerPrepForm = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/EventTypes/Settings/SchedulerForms/Forms/SchedulerPrepForm.vue')
let SchedulerPostForm = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/EventTypes/Settings/SchedulerForms/Forms/SchedulerPostForm.vue')
let EventTypeSettingsView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/EventTypes/EventTypeSettingsView')
let EmptyRouterView = () => import(/* webpackChunkName: "Login" */ '@/core/components/EmptyRouterView.vue')

import formQuestionsAnswersRoutesFn from '../resources/formQuestionsAnswersRoutesFn'
import redirectByName from "@/router/utils/redirectByName";

export default ({mainRouteName, backRouteName, ...otherRoutes}) => {


	let rootName = mainRouteName
	let settingsRouteName = mainRouteName + 'Settings'
	let intakeFormRouteName = mainRouteName + 'IntakeForm'
	let prepFormRouteName = mainRouteName + 'PrepForm'
	let postFormRouteName = mainRouteName + 'PostForm'

	return [
		{
			path:'session/:eventTypeId',
			name: rootName,
			component: EmptyRouterView,
			redirect:redirectByName(settingsRouteName, {schedulerSettingTab: 'general'}),
			meta:{
				backRouteName,
			},
			children:[
				{
					path: "",
					name: "EventTabsRouteName",
					component: EventTypeSettingsView,
					props: mergeProps,
					children:[
						{
							path: ':schedulerSettingTab',
							name: settingsRouteName,
							components: {
								general: EventTypeGeneralSettingsView,
								forms: SchedulerForms,
								intakeform: SessionIntakeFormView,
								availability: EventTypeAvailabilitySettingsView,
								additional: EventTypeAdditionalSettingsView
							},
							props: mergeProps,
							meta:{
								intakeFormRouteName,
								prepFormRouteName,
								postFormRouteName,
								...otherRoutes
							},
						},
					]
				},

				{
					path: 'forms',
					component: EmptyRouterView,
					meta:{
						schedulerSettingTab: "forms",
						backRouteName: settingsRouteName
					},
					props: mergeProps,
					children:[
						{
							path: 'intake',
							component: EmptyRouterView,
							props: mergeProps,
							...formQuestionsAnswersRoutesFn(SchedulerIntakeForm, intakeFormRouteName)

						},
						{
							path: 'prep',
							component: EmptyRouterView,
							props: mergeProps,
							...formQuestionsAnswersRoutesFn(SchedulerPrepForm, prepFormRouteName)
						},
						{
							path: 'post',
							component: EmptyRouterView,
							props: mergeProps,
							...formQuestionsAnswersRoutesFn(SchedulerPostForm, postFormRouteName)
						},
					]
				},
			]
		},
	]
}
